import {
  API_BUILDER_LIMIT,
  GET_SETTING,
  UPDATE_SETTING,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case API_BUILDER_LIMIT:
      return {
        ...state,
        settingPaginationTotal: action.error || action.payload.status !== 200 ? null :action.payload.data.api_builder_limit,
        twoFactorStatus: action.error || action.payload.status !== 200 ? null :action.payload.data.two_factor_status,
      };
    case GET_SETTING:
      return {
        ...state,
        settingPaginationTotal: action.error || action.payload.status !== 200 ? null :action.payload.data.api_builder_limit,
        twoFactorStatus: action.error || action.payload.status !== 200 ? null :action.payload.data.two_factor_status,
      };
      case UPDATE_SETTING:
        return {
          ...state,
          settingPaginationTotal: action.error || action.payload.status !== 200 ? null :action.payload.data.api_builder_limit,
          twoFactorStatus: action.error || action.payload.status !== 200 ? null :action.payload.data.two_factor_status,
      };
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/reducers/settings.js